import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getAptitudes = async (params) => {
	const { data } = await axios.get(`${API}/admin/aptitudes`, {
		params,
	});
	return data;
};

export const getAptitude = async (params) => {
	const { data } = await axios.get(`${API}/admin/aptitudes/detail`, {
		params,
	});
	return data;
};

export const saveAptitud = async (params) => {
	const { data } = await axios.post(`${API}/admin/aptitudes/save`, params);
	return data;
};

export const deleteAptitud = async (params) => {
	const { data } = await axios.post(`${API}/admin/aptitudes/delete`, params);
	return data;
};

export const groupAptitud = async (params) => {
	const { data } = await axios.post(`${API}/admin/aptitudes/group`, params);
	return data;
};
